var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatSendInactiveButton = function SvgChatSendInactiveButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 8,
    fill: "#5E5E5E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4132 11.3182L19.6735 23.6414C19.6082 23.8112 19.5071 23.9704 19.3701 24.1073C18.8466 24.6309 17.9978 24.6309 17.4742 24.1073C17.3018 23.9349 17.1862 23.7273 17.1274 23.5075L15.9252 19.0195C15.8664 18.7998 15.7508 18.5921 15.5784 18.4197C15.406 18.2473 15.1983 18.1316 14.9786 18.0728L10.4905 16.8707C10.2708 16.8118 10.0631 16.6962 9.89072 16.5238C9.36715 16.0003 9.36715 15.1514 9.89072 14.6279C10.0276 14.491 10.1868 14.3899 10.3566 14.3246L22.6799 9.58485C23.1592 9.40045 23.7233 9.50157 24.1099 9.8882C24.4965 10.2748 24.5976 10.8388 24.4132 11.3182Z",
    stroke: "#E3E3E3",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8197 15.17L15.9697 18.02",
    stroke: "#E3E3E3",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgChatSendInactiveButton;